// extracted by mini-css-extract-plugin
export default {"catalogue":"Catalogue_catalogue__kYXBO","visible":"Catalogue_visible__Lhrb7","item":"Catalogue_item__dZ3eR","title":"Catalogue_title__qfnPh","loader":"Catalogue_loader__E8w5z"};